import {
    IUIState,
    UIActionTypes,
    InitUIActionType,
    ChangeViewModeActionType,
    ChangeSettingsActionType,
    ChangeCollaborationActionType,
    ChangeUserOptionsActionType,
    ChangeCurrentPopupActionType,
    ChangeCurrentFieldActionType,
    ChangeSideBarActionType,
    ChangeInputEditingActionType,
    ChangeFormBackgroundActionType,
    ChangeFormBackgroundStyleVisibilityActionType,
    ChangeIsPaginationActiveRequestActionType,
    ChangeIsPaginationActiveSuccessActionType,
    ChangeLogicPopupActionType,
    ChangeCurrentLoginPopupStateActionType,
    ChangeMapScriptStatusActionType,
    ChangePagesViewModeRequestActionType,
    ChangePagesViewModeSuccessActionType,
    ChangePagesViewModeFailureActionType,
    ChangeAuthPopUpRenderActionType,
} from "./types";

import { Handler } from "../types/store-types";
import { ColorPickerModes } from "../../libs/Picker/types.d";

const changeViewMode: Handler<IUIState, ChangeViewModeActionType> = (state, { payload }) => {
    return { ...state, viewMode: payload };
};

const changeSettings: Handler<IUIState, ChangeSettingsActionType> = (state, { payload }) => {
    const { settings } = state;

    return { ...state, settings: { ...settings, ...payload } };
};

const changeCollaboration: Handler<IUIState, ChangeCollaborationActionType> = (state, { payload }) => {
    const { collaboration } = state;

    return { ...state, collaboration: { ...collaboration, ...payload } };
};

const changeUserOptions: Handler<IUIState, ChangeUserOptionsActionType> = (state, { payload }) => {
    const { userOptions } = state;

    return { ...state, userOptions: { ...userOptions, ...payload } };
};

const changeCurrentPopup: Handler<IUIState, ChangeCurrentPopupActionType> = (state, { payload }) => {
    return { ...state, currentPopup: payload };
};

const changeCurrentLoginPopupState: Handler<IUIState, ChangeCurrentLoginPopupStateActionType> = (
    state,
    { payload },
) => {
    return { ...state, currentLoginPopupState: payload };
};

const changeCurrentField: Handler<IUIState, ChangeCurrentFieldActionType> = (state, { payload }) => {
    return { ...state, currentField: payload };
};

const changeInputEditing: Handler<IUIState, ChangeInputEditingActionType> = (state, { payload }) => {
    return { ...state, currentInputEditing: payload };
};

const changeSideBar: Handler<IUIState, ChangeSideBarActionType> = (state, { payload }) => {
    const { sideBar } = state;

    return { ...state, sideBar: { ...sideBar, ...payload } };
};

const changePageViewModeRequest: Handler<IUIState, ChangePagesViewModeRequestActionType> = (state, { payload }) => {
    return { ...state, isVerticalView: payload.isVerticalView };
};

const changePageViewModeSuccess: Handler<IUIState, ChangePagesViewModeSuccessActionType> = (state, { payload }) => {
    return { ...state, isVerticalView: payload.isVerticalView };
};

const changePageViewModeFailure: Handler<IUIState, ChangePagesViewModeFailureActionType> = (state, { payload }) => {
    return { ...state, isVerticalView: !payload.isVerticalView };
};

const initUi: Handler<IUIState, InitUIActionType> = (state, { payload }) => {
    const { isPaginationActive, isVerticalView } = payload;
    return { ...state, isPaginationActive: isPaginationActive, isVerticalView: isVerticalView };
};
const changeFormBackground: Handler<IUIState, ChangeFormBackgroundActionType> = (
    state,
    { payload: { type, style, value } },
) => {
    const newFormBackground: IUIState["formBackground"] = {
        solid: null,
        gradient: null,
        imageUrl: null,
        isStyleVisible: state.formBackground.isStyleVisible,
        lastModified: { type, style, value },
    };

    switch (type) {
        case ColorPickerModes.SOLID:
            newFormBackground.solid = style;
            break;

        case ColorPickerModes.GRADIENT:
            newFormBackground.gradient = style;
            break;

        case ColorPickerModes.IMAGE:
            newFormBackground.imageUrl = style;
            break;
    }

    return { ...state, formBackground: newFormBackground };
};

const changeFormBackgroundStyleVisibility: Handler<IUIState, ChangeFormBackgroundStyleVisibilityActionType> = (
    state,
    { payload: { isVisible } },
) => {
    return { ...state, formBackground: { ...state.formBackground, isStyleVisible: isVisible } };
};

const changePaginationActiveStatusRequest: Handler<IUIState, ChangeIsPaginationActiveRequestActionType> = (
    state,
    { payload },
) => {
    return { ...state, isPaginationActive: payload.isPaginationActive };
};

const changePaginationActiveStatusSuccess: Handler<IUIState, ChangeIsPaginationActiveSuccessActionType> = (
    state,
    { payload },
) => {
    return { ...state, isPaginationActive: payload.isPaginationActive };
};

const changePaginationActiveStatusFailure: Handler<IUIState, ChangeIsPaginationActiveSuccessActionType> = (
    state,
    { payload },
) => {
    return { ...state, isPaginationActive: !payload.isPaginationActive };
};

const changeLogicPopup: Handler<IUIState, ChangeLogicPopupActionType> = (
    state,
    { payload: { isOpen, diffX, diffY, leftPosition, topPosition, currentRuleIndex } },
) => {
    const newLogicPopup = {
        isOpen: isOpen !== undefined ? isOpen : state.logicPopup.isOpen,
        diffX: diffX || state.logicPopup.diffX,
        diffY: diffY || state.logicPopup.diffY,
        leftPosition: leftPosition || state.logicPopup.leftPosition,
        topPosition: topPosition || state.logicPopup.topPosition,
        currentRuleIndex:
            currentRuleIndex || currentRuleIndex === 0 ? currentRuleIndex : state.logicPopup.currentRuleIndex,
    };

    return { ...state, logicPopup: newLogicPopup };
};

const changeMapScriptStatus: Handler<IUIState, ChangeMapScriptStatusActionType> = (
    state,
    { payload: { isLoaded } },
) => {
    return { ...state, mapScriptStatus: isLoaded };
};

const changeAuthPopUpRender: Handler<IUIState, ChangeAuthPopUpRenderActionType> = (state, { payload }) => {
    return { ...state, authPopUpRender: payload.authPopUpRender };
};

export const handlersUI = {
    [UIActionTypes.CHANGE_VIEW_MODE]: changeViewMode,
    [UIActionTypes.CHANGE_SETTINGS]: changeSettings,
    [UIActionTypes.CHANGE_COLLABORATION]: changeCollaboration,
    [UIActionTypes.CHANGE_USER_OPTIONS]: changeUserOptions,
    [UIActionTypes.CHANGE_CURRENT_POPUP]: changeCurrentPopup,
    [UIActionTypes.CHANGE_CURRENT_LOGIN_POPUP_STATE]: changeCurrentLoginPopupState,
    [UIActionTypes.CHANGE_SIDEBAR]: changeSideBar,
    [UIActionTypes.CHANGE_CURRENT_FIELD]: changeCurrentField,
    [UIActionTypes.CHANGE_INPUT_EDITTING]: changeInputEditing,
    [UIActionTypes.CHANGE_PAGE_VIEW_MODE_REQUEST]: changePageViewModeRequest,
    [UIActionTypes.CHANGE_PAGE_VIEW_MODE_SUCCESS]: changePageViewModeSuccess,
    [UIActionTypes.CHANGE_PAGE_VIEW_MODE_FAILURE]: changePageViewModeFailure,
    [UIActionTypes.CHANGE_FORM_BACKGROUND]: changeFormBackground,
    [UIActionTypes.CHANGE_FORM_BACKGROUND_VISIBILITY]: changeFormBackgroundStyleVisibility,
    [UIActionTypes.CHANGE_PAGINATION_ACTIVE_STATUS_REQUEST]: changePaginationActiveStatusRequest,
    [UIActionTypes.CHANGE_PAGINATION_ACTIVE_STATUS_SUCCESS]: changePaginationActiveStatusSuccess,
    [UIActionTypes.CHANGE_PAGINATION_ACTIVE_STATUS_FAILURE]: changePaginationActiveStatusFailure,
    [UIActionTypes.CHANGE_LOGIC_POPUP]: changeLogicPopup,
    [UIActionTypes.INIT_UI]: initUi,
    [UIActionTypes.CHANGE_MAP_SCRIPT_STATUS]: changeMapScriptStatus,
    [UIActionTypes.CHANGE_AUTH_POPUP]: changeAuthPopUpRender,
};
